export const enum VisualPosition {
  TOP = 'Top',
  RIGHT = 'Right',
  LEFT = 'Left',
  CENTERED = 'Centered',
  DEFAULT = 'Default for current module'
}

export type VisualPositionOption = `${VisualPosition}`;
